import { project2BaseUrl } from './remoteClient'

export async function requestJobProfiles(token) {
    return await project2BaseUrl.get('/jobProfiles/getJobProfiles', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export async function createJobProfile(token, jobProfile) {
    return await project2BaseUrl.post('/jobProfiles/createJobProfile', jobProfile, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })

}

export async function updateJobProfile(token, jobProfile) {
    return await project2BaseUrl.post('/jobProfiles/updateJobProfile', jobProfile, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export async function deleteJobProfile(token, profileId) {
    return await project2BaseUrl.post('/jobProfiles/deleteJobProfile', profileId, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}




